import { Box, MantineStyleProps, Stack, Text } from "@mantine/core"
import { CSSProperties } from "react"
import { useAEMIcons } from "@AEM/hooks/useAEMIcons"
import { AEMImage } from "@components/AEMImage"

interface LoadingOverlayProps extends MantineStyleProps {
	loading: boolean
	loadingText?: string
	style?: CSSProperties
	className?: string
}

export function LoadingOverlay({
	loading,
	loadingText,
	style,
	bg = "var(--mantine-color-royal-6)",
	className
}: LoadingOverlayProps) {
	const { icons } = useAEMIcons()
	const cPLogo = icons["Cruising-Power-Logo-icon.svg"]

	if (!loading) return null
	return (
		<Box
			pos="absolute"
			top={-1}
			left={-1}
			right={-1}
			bottom={-1}
			bg={bg}
			style={{
				zIndex: 1000,
				borderRadius: "inherit",
				...style
			}}
			className={className}
		>
			<Stack align="center" justify="center" h="100%" gap={16}>
				<Box w={80} h={88}>
					<AEMImage imageData={cPLogo} />
				</Box>
				<Text fz={18} fw={500}>
					{loadingText}
				</Text>
			</Stack>
		</Box>
	)
}
